module.exports = __webpack_public_path__ + "img/menu-transaction-white.53291358.svg";